import { store } from '../store/store'
import moment from 'moment'

export default class WebSocketClient {
  constructor () {
    this.connect()
  }

  connect () {
    this.KEEP_ALIVE = false
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      console.log('Socket is already open! Cancelling reconnect')
      return
    }

    var url = this.getDefaultUri()
    this.socket = new WebSocket(url)

    let C = this

    this.socket.onopen = (e) => {
      C.onOpen(e)
    }
    this.socket.onclose = (e) => {
      C.onClose(e)
    }
    this.socket.onerror = (e) => {
      // do nothing
      // console.log(e)
    }
    this.socket.onmessage = (msg) => {
      var jsonObj = JSON.parse(msg.data)

      if (jsonObj.channel === 'store') {
        // Store methods
        if (jsonObj.msg.model === 'currency-rates') {
          store.dispatch('db/currencyRates/fetchAll')
        } else if (jsonObj.msg.model === 'inventory-definitions') {
          store.dispatch('db/inventoryDefinitions/fetchAll')
        } else if (jsonObj.msg.model === 'deliveries') {
          // store.dispatch('db/deliveries/fetchAll')
        } else if (jsonObj.msg.model === 'delivery-items') {
          store.dispatch('db/deliveryItems/fetchAll')
        } else if (jsonObj.msg.model === 'inventory') {
          store.dispatch('db/inventory/fetchAll')
        } else if (jsonObj.msg.model === 'inventory-archive') {
          store.dispatch('db/inventoryArchive/fetchAll')
        } else if (jsonObj.msg.model === 'suppliers') {
          store.dispatch('db/suppliers/fetchAll')
        } else if (jsonObj.msg.model === 'product-build-items') {
          store.dispatch('db/productBuilds/fetchBuildItems')
        } else if (jsonObj.msg.model === 'product-builds') {
          store.dispatch('db/productBuilds/fetchBuilds')
        } else if (jsonObj.msg.model === 'production') {
          // store.dispatch('db/production/fetchAll')
        } else if (jsonObj.msg.model === 'production-outputs') {
          store.dispatch('db/productionOutputs/fetchProductionOutputs')
        } else if (jsonObj.msg.model === 'production-inputs') {
          store.dispatch('db/productionInputs/fetchProductionInputs')
        } else if (jsonObj.msg.model === 'customers') {
          store.dispatch('db/customers/fetchAll')
        } else if (jsonObj.msg.model === 'addresses') {
          store.dispatch('db/addresses/fetchAll')
        } else if (jsonObj.msg.model === 'sales') {
          store.dispatch('db/sales/fetchAll')
        } else if (jsonObj.msg.model === 'sales-items') {
          store.dispatch('db/salesItems/fetchAll')
        } else if (jsonObj.msg.model === 'settings') {
          store.dispatch('settings/fetchAll')
        } else if (jsonObj.msg.model === 'users') {
          store.dispatch('db/users/fetchAll')
        }
      }
    }
  }

  send (channel, data) {
    this.socket.send(JSON.stringify({channel: channel, data: data}))
  }

  getDefaultUri () {
    if (process.env.NODE_ENV === 'production') {
      var socketUri
      var loc = window.location
      if (loc.protocol === 'https:') {
        socketUri = 'wss:'
      } else {
        socketUri = 'ws:'
      }
      socketUri += '//' + loc.host + '/socket'
      // socketUri += loc.pathname + 'socket'
      console.log('connecting to: ' + socketUri)
      return socketUri
    }
    return 'ws://localhost:8301'
  }

  onClose (e) {
    // console.log('-----Websocket disconnected')
    // console.log(e)
    // console.log(moment().format())
    store.commit('SOCKET_DISCONNECT', true)

    if (this.KEEP_ALIVE) {
      setTimeout(this.connect.bind(this), 4000)
    }
  }

  onOpen (e) {
    // console.log('-----WEBSOCKET CONNECTED, attempting handshake')
    this.send('auth', localStorage.getItem('token'))
    store.commit('SOCKET_CONNECT')
    // refetch all data if last sync occured more than
    // 5 seconds ago
    // This prevents doulbe sync after loading screen
    // and socket connection happen sequentially
    var now = moment()
    var then = moment(store.state.db.lastSync)
    var diff = now.diff(then, 'seconds')
    if (diff > 5) {
      store.dispatch('syncAllData')
    }
  }

  dropConnection () {
    this.KEEP_ALIVE = false
    this.socket.close()
  }
}
